import '@emotion/react';

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var _ref = process.env.NODE_ENV === "production" ? {
  name: "4zleql",
  styles: "display:block"
} : {
  name: "czbzyg-getImageStyles",
  styles: "display:block;label:getImageStyles;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkltYWdlUHJldmlld1N0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHSSIsImZpbGUiOiJJbWFnZVByZXZpZXdTdHlsZXMudHMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjc3MsIFNlcmlhbGl6ZWRTdHlsZXMgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmV4cG9ydCBjb25zdCBnZXRJbWFnZVN0eWxlcyA9ICgpOiBTZXJpYWxpemVkU3R5bGVzID0+XG4gICAgY3NzKHtcbiAgICAgICAgZGlzcGxheTogJ2Jsb2NrJyxcbiAgICB9KTtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const getImageStyles = () => _ref;

export { getImageStyles };
//# sourceMappingURL=ImagePreviewStyles.js.map
